var _path, _path2, _path3, _path4, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 45L15.9645 13L30.5035 40.4033H31.2128L35.2908 32.4475L36 35.453L31.2128 43.9392H30.5035L16.8511 18.3039L12.9504 43.0553H17.7376L19.156 33.3315L20.3972 35.453L19.156 45H11Z",
    stroke: "#121212",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 41.8571H15L17.6667 23L29 45H27L18.5 28.4127L16.6667 41.8571Z",
    stroke: "#121212",
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7692 13H17L29.7385 37.967H30.4462L35.7538 27.7692L38.0538 45H40L36.4615 22.6703L30.4462 33.9231H29.7385L18.7692 13Z",
    stroke: "#121212",
    strokeWidth: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0408 30.6796L30 28.9116L38.6735 13H42.3163L47 45H41.7959L38.1531 20.0718L39.7143 18.1271L43.3571 43.4088H44.9184L40.5816 14.5912H39.3673L31.0408 30.6796Z",
    stroke: "#121212",
    strokeWidth: 0.4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.9,
    y: 5.9,
    width: 42.2,
    height: 46.2,
    rx: 2.1,
    stroke: "#7575F1",
    strokeWidth: 1.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 53,
    height: 53,
    stroke: "#FB026A",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogoLight);
export default __webpack_public_path__ + "static/media/mainLogoLight.1b2e6fa5e69051974712d593a5f517e4.svg";
export { ForwardRef as ReactComponent };